module.exports = __webpack_public_path__ + "img/luka_web.ac7bd14f.png";